import React from 'react';
import "./index.scss";
import {Outlet} from 'react-router-dom';
import {HashLink as Link} from 'react-router-hash-link';
import Container from "../../components/Container";

const LoginLayout = () => {

    return (
        <Container>
            <Outlet/>
        </Container>
    );
};

export default LoginLayout;
